<script lang="ts" setup>
import { nullCoalesce } from '@collector/shared-utils'
import Button from '@mobile/components/Button/Button.vue'

import IncrementableNumberValueChangeContent from './IncrementableNumberValueChangeContent.vue'

type Props = {
  title?: string
  min?: number
  max?: number
  baseValue?: number
  testId?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'Value',
  min: 0,
  max: 100,
})

// model
const model = defineModel<number>({
  default: 0,
})
if (props.baseValue) {
  model.value = props.baseValue
}

// emits
const emit = defineEmits(['subtracted', 'incremented'])

// methods
function subtract(): void {
  model.value -= 1
  emit('subtracted', model.value)
}

function increment(): void {
  model.value += 1
  emit('incremented', model.value)
}
</script>

<template>
  <div class="flex gap-4">
    <div class="text-gray flex w-[100px] items-center text-base font-bold">
      {{ title }}
    </div>
    <div
      class="flex gap-3"
      :data-testid="props.testId"
    >
      <Button
        class="mb-2 w-12 text-xl"
        color="white"
        size="md"
        :disabled="model === min"
        @click="subtract"
      >
        -
      </Button>
      <div class="flex flex-col items-center justify-center text-xl font-bold">
        <slot name="content">
          <IncrementableNumberValueChangeContent>
            <template #leftSide>{{ baseValue }}</template>
            <template #rightSide>{{ model }}</template>
          </IncrementableNumberValueChangeContent>
          <IncrementableNumberValueChangeContent>
            <template #leftSide>
              {{ baseValue }}/{{ nullCoalesce(1, 0) }}
            </template>
            <template #rightSide>{{ model }}/{{ nullCoalesce(1, 0) }}</template>
          </IncrementableNumberValueChangeContent>
        </slot>
      </div>
      <Button
        class="mb-2 w-12 text-xl"
        color="white"
        size="md"
        :disabled="model === max"
        @click="increment"
      >
        +
      </Button>
    </div>
  </div>
</template>
